import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-orderable"]

import { computed, inject, useCssModule } from 'vue';
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import BaseInput from '@/shared/legacy/ui/input/input.vue';
import RemoveButton from './remove-button.vue';

type Props = {
  id: number | string;
  name?: string;
  value?: string;
  disabled?: boolean;
  invalid?: boolean;
  isNew?: boolean;
  index: number;
  draggable?: boolean;
  removable?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'item',
  props: {
    id: {},
    name: {},
    value: {},
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    index: {},
    draggable: { type: Boolean, default: true },
    removable: { type: Boolean, default: true }
  },
  emits: ["input", "remove"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const draggableDragHandlerClass = inject('$draggableDragHandlerClass') as string;
const draggableFilterClass = inject('$draggableFilterClass') as string;

const style = useCssModule();

const containerClassName = computed(() => ({
  [style.container]: true,
  [style.removable]: __props.removable,
  [style.draggable]: __props.draggable,
  [draggableFilterClass]: !__props.draggable
}));

const dragHandlerClassName = computed(() => ({
  [style.dragHandler]: true,
  [draggableDragHandlerClass]: true
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    "data-qa": "item",
    "data-index": "index",
    "data-orderable": __props.draggable,
    style: _normalizeStyle(_unref(style)),
    class: _normalizeClass(containerClassName.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.controls)
    }, [
      (__props.draggable)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(dragHandlerClassName.value)
          }, "☰", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.field)
      }, [
        _createVNode(BaseInput, {
          value: __props.value,
          disabled: __props.disabled,
          invalid: __props.invalid,
          class: _normalizeClass(_ctx.$style.input),
          "data-qa": "input",
          size: "full",
          name: __props.name,
          focus: __props.isNew,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('input', $event)))
        }, null, 8, ["value", "disabled", "invalid", "class", "name", "focus"]),
        (!__props.removable)
          ? (_openBlock(), _createBlock(BaseIcon, {
              key: 0,
              class: _normalizeClass(_ctx.$style.lock),
              type: "lock",
              width: 8,
              height: 10
            }, null, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.removable)
          ? _renderSlot(_ctx.$slots, "remove", { key: 1 }, () => [
              _createVNode(RemoveButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('remove', __props.id)))
              })
            ])
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _renderSlot(_ctx.$slots, "footer")
  ], 14, _hoisted_1))
}
}

})